
import Ripple from 'primevue/ripple';

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.directive('ripple', Ripple);
})